import { useState } from "react";
import GeneralInformationTwilio from "./GeneralInformation";
import ContentTypeSelector from "./ContentTypeSelector";
import { useHistory } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../Components/Form";
import { ACESSOS } from "../../../Routes/Acessos";

export default function CadastrarTemplateTwilio() {
    const [name, setName] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const history = useHistory();

    function handleSubmit(formData: any) {
        if (!name || !selectedType) return;
        history.push(
            `/HelpDesk/GestaoTemplates/ConfigurarTemplatesTwilio/${name}/${selectedType}`
        );
    }

    return (
        <UnForm
            handleSubmit={handleSubmit}
            className="bg-white rounded p-8 mt-5"
        >
            <h1>Criar novo template</h1>
            <GeneralInformationTwilio name={name} onNameChange={setName} />
            <ContentTypeSelector
                selectedType={selectedType}
                onSelectType={setSelectedType}
            />
            <div className="d-flex justify-content-start align-items-center mt-10">
                <div className="p-0 m-0">
                    <UnForm.SubmitButton
                        color="primary"
                        icon={faPlus}
                        wrapperClassName="m-0"
                    >
                        Criar
                    </UnForm.SubmitButton>
                </div>
                <div>
                    <button
                        className="btn btn-secondary ml-2"
                        type="button"
                        onClick={() => {
                            history.push(
                                ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH
                            );
                        }}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </UnForm>
    );
}
